import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.bookassignment.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_BOOK_ASSIGNMENT_ASYNC: `${uid}.saveBookAssignmentAsync`,
    SAVE_BOOK_ASSIGNMENT_SUCCESS: `${uid}.saveBookAssignmentSuccess`,
    SAVE_BOOK_ASSIGNMENT_FAILURE: `${uid}.saveBookAssignmentFailure`,
    SELECT_COURSE_TYPE: `${uid}.selectCourseType`
};

export { ActionTypes };
